var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__loader",class:{ 'form__loader--loading': _vm.isLoading }},[_c('div',[_c('span',{staticClass:"loader__text"},[_vm._v(_vm._s(_vm.loadingText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }